import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Supplier} from "../../../shared/view-model/crm/supplier.type";
import {appInjector} from "../../../index";
import {AddressFormComponent} from "../../../core/visbos-core/ui/forms/address-form/address-form.component";
import {SupplierBusinessRelationsFormComponent} from "../../business-relations/supplier-business-relations-form/supplier-business-relations-form.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {SupplierService} from "../../services/supplier/supplier.service";

@Component({
  selector: 'vb-supplier-form',
  templateUrl: './supplier-form.component.html',
  styleUrls: ['./supplier-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => SupplierFormComponent)}]
})
export class SupplierFormComponent extends AbstractVisbosControl<Supplier, FormGroup> {


  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions,
              private supplierService: SupplierService) {
    super(fb, cd, sessionActions);
  }

  buildControlContent(): FormGroup {
    return SupplierFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null],
      name: [null, Validators.required],
      administration_unit_id: [null, Validators.required],
      address_name: [null],
      address: AddressFormComponent.initControl(fb),
      business_relations: fb.array([SupplierBusinessRelationsFormComponent.initControl(fb)])
    });

  }

  public setDefaultValues(item?: Supplier): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      name: this.setValue(item, 'name'),
      address_name: this.setValue(item, 'address_name')
    };
  }

  reset(fullReset: boolean = false): any {
    let br = (<FormArray>this.control.get('business_relations'));

    br.controls = [];
    br.push(SupplierBusinessRelationsFormComponent.initControl(this.fb));

    super.reset(fullReset);
  }

  private transformToOutput(formData): { supplierInput, relationsData } {

    let supplierInput = Object.assign({}, formData);
    delete supplierInput.business_relations;
    let relationsData = null;

    if (formData.business_relations) {
      supplierInput.business_relations = [...formData.business_relations.map(rel => rel.relation)];
      relationsData = [...formData.business_relations.map(rel => rel.relation_data)];
    }

    let result = {
      supplierInput: supplierInput,
      relationsData: relationsData
    };

    return result;
  }

  createOrUpdateSupplier() {
    let supplierData = this.transformToOutput(this.control.value);

    if (this.item) {
      this.supplierService.updateSupplier(this.item.cuid, supplierData.supplierInput, supplierData.relationsData)
        .toPromise()
        .then((res: any) => {
            this.sessionActions.pushMessage('Lieferant erfolgreich geändert.', MessageType.SUCCESS, 'Lieferantenverwaltung');
            this.reset(true);
          },
          err => this.sessionActions.throwError(err, 'Fehler beim Ändern des Lieferanten!'));
    } else {
      this.supplierService.createSupplier(supplierData.supplierInput, supplierData.relationsData)
        .toPromise()
        .then((res: any) => {
            this.sessionActions.pushMessage('Lieferant erfolgreich angelegt.', MessageType.SUCCESS, 'Lieferantenverwaltung');
            this.reset(true);
          },
          err => this.sessionActions.throwError(err, 'Fehler beim Anlegen des Lieferanten!'));
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/supplier/supplier-form/supplier-form.component.ts